// extracted by mini-css-extract-plugin
export var actions = "_3o-0";
export var actionsContainer = "_3o-7";
export var border = "_3o-1";
export var childFullHeight = "_3o-f";
export var collapse = "_3o-2";
export var content = "_3o-a";
export var contentChild = "_3o-e";
export var fullscreen = "_3o-c";
export var hasLeftRadius = "_3o-k";
export var headerContainer = "_3o-3";
export var headerRow = "_3o-5";
export var hidePadding = "_3o-b";
export var navCollapsedGap = "_3o-l";
export var noScrollX = "_3o-m";
export var noScrollY = "_3o-n";
export var noTopPadding = "_3o-i";
export var optOutTopPadding = "_3o-d";
export var pageMain = "_3o-j";
export var pageOuter = "_3o-g";
export var pagePadding = "_3o-8";
export var pageScroll = "_3o-9";
export var profile = "_3o-o";
export var profileContainer = "_3o-p";
export var profileImage = "_3o-q";
export var profileMain = "_3o-r";
export var profileSubtitle = "_3o-t";
export var profileTitle = "_3o-s";
export var showLeftPadding = "_3o-h";
export var tabsPortalSlot = "_3o-6";
export var tabsWrapper = "_3o-4";
export var title = "_3o-u";